import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const GlobeIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-globe', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.87575 12.0853C10.3235 11.4763 10.6663 10.8635 10.9137 10.25H11.8918C11.426 11.051 10.7218 11.6945 9.87575 12.0853ZM4.109 10.25H5.102C5.3525 10.865 5.69525 11.48 6.14375 12.095C5.28875 11.705 4.57775 11.0577 4.109 10.25ZM6.104 3.9245C5.6585 4.529 5.315 5.13725 5.07125 5.75H4.109C4.57025 4.955 5.267 4.316 6.104 3.9245ZM8.375 9.5V6.5H10.3827C10.538 7.0025 10.625 7.5035 10.625 8C10.625 8.4965 10.538 8.9975 10.3827 9.5H8.375ZM8.375 12.4805V10.25H10.0955C9.7595 10.982 9.266 11.7185 8.6075 12.4535C8.531 12.4648 8.45375 12.4745 8.375 12.4805ZM7.625 10.25V12.4805C7.54925 12.4753 7.47575 12.4655 7.4015 12.455C6.749 11.717 6.25625 10.9805 5.9195 10.25H7.625ZM7.625 3.51875V5.75H5.8895C6.224 5.015 6.71975 4.27925 7.38275 3.54725C7.463 3.53675 7.544 3.5255 7.625 3.51875ZM8.375 3.51875C8.45375 3.5255 8.531 3.53525 8.60825 3.54575C9.266 4.2815 9.76025 5.01725 10.0955 5.75H8.375V3.51875ZM5.375 7.96175C5.37425 7.47575 5.4575 6.98825 5.60525 6.5H7.625V9.5H5.62925C5.46725 8.98325 5.37575 8.47025 5.375 7.96175ZM3.5 8C3.5 7.4735 3.59525 6.97025 3.7625 6.5H4.82075C4.6925 6.98675 4.62425 7.475 4.625 7.96325C4.62575 8.474 4.70375 8.98625 4.84475 9.5H3.7625C3.59525 9.02975 3.5 8.5265 3.5 8ZM12.5 8C12.5 8.5265 12.4047 9.02975 12.2375 9.5H11.1672C11.3015 8.99975 11.375 8.4995 11.375 8C11.375 7.5005 11.3015 7.00025 11.1672 6.5H12.2375C12.4047 6.97025 12.5 7.4735 12.5 8ZM11.8918 5.75H10.9137C10.6663 5.13575 10.3235 4.52375 9.87575 3.914C10.7218 4.30475 11.426 4.94825 11.8918 5.75ZM8 2C4.6865 2 2 4.6865 2 8C2 11.3135 4.6865 14 8 14C11.3135 14 14 11.3135 14 8C14 4.6865 11.3135 2 8 2Z'
      />
    </svg>
  );
};

export default GlobeIcon;
